import { THREE } from '@powerplay/common';
export const renderOptions = [
    [55, 15, 1, 1],
    [65, 20, 1, 1],
    [65, 25, 1, 2],
    [80, 35, 1, 2],
    [80, 55, 512, 4],
    [90, 70, 512, 4],
    [90, 80, 1024, 8],
    [100, 90, 1024, 8],
    [100, 100, 2048, 16]
];
export const lightConfig = {
    lightVector: new THREE.Vector3(-30, 70, -33)
};
//# sourceMappingURL=index.js.map